'use client';

import { useId } from 'react';
import { Clock, Info } from 'lucide-react';
import inlineStyles from '../../editar/shared/inline-collection/inlineCollection.module.css';
import type { PildoraAdscripcion } from './adscripcionEdicion';
import styles from './adscripcionPildora.module.css';

const ESTILO_POR_TONO: Record<PildoraAdscripcion['tono'], string> = {
	revision: inlineStyles.autoSortInfoBadgeWarning,
	inmediato: inlineStyles.autoSortInfoBadgeNeutral,
	// The plain info look of the shared pill (blue): it is a notice, not a warning and not "all done".
	pendiente: '',
};

/**
 * A pill of the modal header: the same pill and tooltip as "Orden automático" in the collection modals (opens on hover or
 * keyboard focus). Orange when an administrator will review part of the edition, neutral when it all applies at once, blue
 * for the request that is already waiting. The tooltip is read as groups: a heading line, then one bullet per change.
 * Presentational: what it says comes from `pildoraDeAdscripcion` / `pildoraSolicitudPendiente`.
 */
export function AdscripcionPildora({ pildora }: { pildora: PildoraAdscripcion }) {
	const idTooltip = useId();
	const Icono = pildora.tono === 'pendiente' ? Clock : Info;
	return (
		<span
			className={`${inlineStyles.autoSortInfoBadge} ${ESTILO_POR_TONO[pildora.tono]} ${styles.pildora}`}
			tabIndex={0}
			aria-label={pildora.titulo}
			aria-describedby={idTooltip}
		>
			<Icono size={13} aria-hidden="true" />
			<span className={`${inlineStyles.autoSortInfoLabel} ${styles.rotulo}`}>{pildora.titulo}</span>
			<span id={idTooltip} className={`${inlineStyles.autoSortInfoPopover} ${styles.tooltip}`} role="tooltip">
				{pildora.bloques.map((bloque, indice) => (
					<span key={`${bloque.tipo}-${indice}`} className={styles.bloque}>
						<span className={styles.encabezado}>{bloque.encabezado}</span>
						{bloque.puntos.length > 0 ? (
							<ul className={styles.puntos}>
								{bloque.puntos.map((punto) => (
									<li key={punto}>{punto}</li>
								))}
							</ul>
						) : null}
					</span>
				))}
			</span>
		</span>
	);
}
